import './components/wordmark.ts';
import './components/track-chip.ts';
import { registerMediaCache } from './lib/media-cache.ts';
import { mountViewer } from './views/viewer.ts';

// The local media cache installs itself in the background and is never
// waited for: the player streams identically whether the worker is
// there or not, and caching simply begins once it takes control.
registerMediaCache();

// The marks render only in their true typeface: painted in the
// fallback and repainted on font arrival, their edges would shift.
// The scenography must never move once shown, so the header stays
// dark until the faces are in. fonts.ready resolves on failure too,
// so the marks can never be held back indefinitely.
void document.fonts.ready.then(() => {
  document.documentElement.setAttribute('data-fonts', 'ready');
});

const root = document.getElementById('app');
if (!root) {
  throw new Error('missing #app mount point');
}

const path = window.location.pathname;
const shareMatch = path.match(/^\/s\/([A-Za-z0-9_-]+)$/);

if (shareMatch && shareMatch[1]) {
  void mountViewer(root, shareMatch[1]);
} else if (path === '/admin' || path.startsWith('/admin/')) {
  // The console is code-split: viewers never download operator code.
  void import('./views/admin.ts').then(({ mountAdmin }) => mountAdmin(root));
} else {
  // No public landing content: the interface presents material through
  // shares, it does not promote itself.
  root.innerHTML = `
    <div class="frame">
      <header>
        <eternally-wordmark></eternally-wordmark>
        <div class="brandmark" role="img" aria-label="Thåst Works"><span>Thåst</span><span>Works</span></div>
      </header>
      <main></main>
      <footer></footer>
    </div>
  `;
}
